export default (function (env) {
  var warned = false;
  return function (message) {
    if (process.env.NODE_ENV === env && !warned) {
      warned = true;
      console.warn(message);
    }
  };
});